import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    margin: 0;
    --colorPrimary: ${({ theme }) => theme.colorPrimary};
    --colorSecondary: ${({ theme }) => theme.colorSecondary};
    --colorBgContainer: ${({ theme }) => theme.colorBgContainer};
    --borderRadius: ${({ theme }) => theme.borderRadius}px;
    --borderColor: #f0f0f0;
  }

  .ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .ant-modal {
    .ant-modal-content {
      padding: 0;
      .ant-modal-header {
        padding: 16px 24px;
        border-bottom: 1px solid var(--borderColor);
        margin-bottom: 0;
      }
      .ant-modal-body {
        padding: 24px;
      }
      .ant-modal-footer {
        background-color: rgba(0, 0, 0, 0.02);
        border-top: 1px solid var(--borderColor);
        padding: 12px 24px;
        margin-top: 0;
      }
    }
  }

  .ant-table-tbody {
    .ant-table-cell {
      vertical-align: top;
      white-space: pre-wrap;
    }
  }

  .m-0 {
    margin: 0;
  }
`;
